import { Logo } from '../componentes/Logo'

/** Sin sesión no hay portal. Se entra con Discord: no hay contraseñas que gestionar. */
export default function Entrar() {
  return (
    <div className="entrar">
      <div className="entrar__caja">
        <Logo ancho={200} className="logo--grande" />
        <h1>Portal administrativo</h1>
        <p>
          Solicitudes de desarrollo, tareas y proyectos del servidor. Se entra con la misma
          cuenta de Discord con la que estás en el servidor.
        </p>
        <a className="boton boton--principal" href="/api/auth/login">
          Entrar con Discord
        </a>
        <div className="entrar__pie">Barcelona PD · herramienta interna</div>
      </div>
    </div>
  )
}
